import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service'; // Assuming ApifirstService is your shared service
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { FdrsClientService } from '../../service/fdrs-client.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-close-cancel-diagnosis',
  templateUrl: './close-cancel-diagnosis.component.html',
  styleUrls: ['./close-cancel-diagnosis.component.scss', './close-cancel-diagnosis.component1.scss']
})
export class CloseCancelDiagnosisComponent implements OnInit, OnDestroy { // Implement OnDestroy
  vinNumber: any
  public userId: any
  public tokenDetails: any
  public Vinnumber: any
  public infotab: boolean = false;
  public hintstab: boolean = false;
  public submittab: boolean = false;
  vin: any
  dealerCode: any
  countrythree: any
  modelYear: any
  username: any
  market: any;
  maxFailureTimes: number = 0;
  public userType: any;
  userTypeId: any;
  vindetails: any
  vehicle: any
  language: any
  country: any
  isSessionCreated: boolean = false;
  isFDRSConnected: boolean = false;
  isNetworkTestNeeded: boolean = false;
  isUserAdmin: boolean = false;
  isShowOverrideBlock: boolean = false;
  isShowReRunBlock: boolean = false;
  progressbar: boolean = false;
  isShowTestProgressBlock: boolean = false;
  isDisableNwHeader: boolean = false;
  isNWTestFailedAdmin: boolean = false;
  isNWTestFailedMultiple: boolean = false;
  isNetwork: boolean = false;
  isNetworkFailure: boolean = false;
  public retryNetworkTestCount: number = 0;
  isNetworkTestError: boolean = false;
  public resume: boolean = false;
  isFromRepairComplete: boolean = false;
  networkTestErrorMsg: string = '';
  @ViewChild('NWTInfo') NWTErrorInfo: ElementRef | undefined;
  NWTStatus: Subscription = new Subscription;
  webSocketsubscription: Subscription = new Subscription;
  freshWebSocetSubscription: Subscription = new Subscription;
  @ViewChild('DTCInfo') DTCInfo: ElementRef | undefined;
  isFDRSWebSoecketConnected: boolean = true;
  showLoader: boolean = false;
  noOfWebSocketConnRetry: number = 0;
  networkTestState: string = 'onPageLoad';
  info: string = ''
  isShowDataCollectorCheckBox: boolean = false;
  isDataCollectorChecked: boolean = false;
  dataCollectorEvent: string = '';
  dataCollectorSessionId: string = '';
  reasonKey="";
  // Properties to receive state from StartupComponent via ApifirstService
  public showWhatsNewContainer: boolean = false;
  public whatsNewHasScrollbar: boolean = false;
  private showWhatsNewSubscription: Subscription = new Subscription();
  private whatsNewScrollSubscription: Subscription = new Subscription();


  constructor(private modalService: NgbModal, private service: ApifirstService, private rpcClientService: RpcClientService, private fdrsClient: FdrsClientService, public router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    // Subscribe to Whats New container presence from the shared service
    this.showWhatsNewSubscription = this.service.showWhatsNew$.subscribe(value => {
      this.showWhatsNewContainer = value;
      console.log(`CloseCancelDiagnosisComponent: Whats New Container Present: ${this.showWhatsNewContainer}`);
    });

    // Subscribe to Whats New scrollbar presence from the shared service
    this.whatsNewScrollSubscription = this.service.hasScrollbar$.subscribe(
      (hasScrollbar: boolean) => {
        this.whatsNewHasScrollbar = hasScrollbar;
        console.log(`CloseCancelDiagnosisComponent: Received scrollbar state: ${this.whatsNewHasScrollbar}`);
      }
    );

    // Get initial values from the BehaviorSubjects (they will emit immediately upon subscription too)
     this.service.showWhatsNew$.subscribe(d =>{
       this.showWhatsNewContainer = d;
    });
    this.whatsNewHasScrollbar = this.service.getCurrentHasScrollbar();


    this.info = this.translate.instant('dtcClearInformation');
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data;
      this.Vinnumber = this.tokenDetails.vin;

      let c: any
      c = data
      this.language = c.language
      this.country = c.country
      this.dealerCode = c.dealerCode
      this.countrythree = c.countryThree
      this.vin = c.vin
      this.username = c.username
      this.userType = c.userType
      this.market = c.marketCountry
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.userTypeId = 1
        } else if (this.userType == 'PTS_DEALER') {
          this.userTypeId = 3;
        } else if (this.userType == 'PTS_AFTERMARKET') {
          this.userTypeId = 2;
        }
      }
    })

    this.Vinnumber = this.tokenDetails.vin

    this.service.isSessionCreated.subscribe((data) => {
      this.isSessionCreated = data;
    })

    this.service.userId.subscribe((data) => {
      this.userId = data;
    })

    this.service.fdrsErorCode.subscribe(()=> {
      this.showLoader = false;
      this.isFDRSWebSoecketConnected = false;
    })

    this.service.isHomeNWTBtnCilcked.next(true);

     this.service.showDataCollectorCheckBox.subscribe((data)=> {
      this.isShowDataCollectorCheckBox = data;
     })

    this.service.showSBDAdminTab.subscribe((data) => {
      this.isUserAdmin = data;
    })

    // Intial data collector checkbox unchecked, so set to skip_specific if it is data collector vin.
    if(this.isShowDataCollectorCheckBox) {
      this.service.dataCollectorInfo.next('SKIP_SPECIFIC');
     } else {
      this.service.dataCollectorInfo.next('FULL');
     }

    this.webSocketsubscription = this.service.getWebsocketStatus.subscribe((data) => {
      console.log("--websocket status---", data);
      if (data == 'true') {
        switch (this.networkTestState) {
          case "startNWT":
            this.showStartNetworkTestBlock();
            break;
          case "reRunNWT":
            this.showReRunNetworkTestBlock();
            break;
          case "retryNWT":
            this.showRetryNetworkTestBlock();
            break;
          case "onPageLoad":
            this.ShowNetworkTestBlock();
            break;
        }

      } else if (data == 'false') {
        console.log("<--- Websocket: False---->")
        this.service.isShowFDRSLoader.next(false);
        this.noOfWebSocketConnRetry = this.noOfWebSocketConnRetry + 1;
        if (this.noOfWebSocketConnRetry < 2) {
          this.showNetworkTestErrorBlock();
        }
      }
    })

    this.freshWebSocetSubscription = this.service.freshWebSocketConnStatus.subscribe((data) => {
      console.log("--freshwebsocket status---", data);
      if (data == 'true') {
        switch (this.networkTestState) {
          case "startNWT":
            this.showStartNetworkTestBlock();
            break;
          case "reRunNWT":
            this.showReRunNetworkTestBlock();
            break;
          case "retryNWT":
            this.showRetryNetworkTestBlock();
            break;
          case "onPageLoad":
            this.ShowNetworkTestBlock();
            break;
        }
      } else if (data == 'false') {
        console.log("<---fresh Websocket: False---->")
        this.showLoader = false;
        this.service.isShowFDRSLoader.next(false);
        this.isFDRSWebSoecketConnected = false;
      }
    });

    // New logic:
    this.retryFDRSConnection();

    // this.service.fromResume.subscribe((data) => {
    //   this.resume = data
    //   console.log("---isfromResume---", data);
    // })

    this.service.isFromRepairComplete.subscribe((data) => {
      this.isFromRepairComplete = data;
    })


    this.NWTStatus = this.service.isFDRSNetworkTest$.subscribe((data: any) => {
      this.isDataCollectorChecked = false;
      console.log("-----N/W Test Subscriber-----")
      // if (!this.resume) {
      if (data.status) {
        localStorage.setItem('DCSessionId', '');
        this.isNetwork = data.status;
        setTimeout(() => {
          this.isShowTestProgressBlock = false;
          // this.isNetworkTestNeeded = false;
          this.isShowReRunBlock = true;
        }, 5000);
        this.service.isNWTInProgress.next('NWTNotRunning');

        let sessionId:any = '';
          if(this.dataCollectorEvent == 'FULL') {
              sessionId = this.dataCollectorSessionId;
          } else {
              sessionId = localStorage.getItem("sessionID")
          }

        let obj = {
          "sessionID": sessionId,
          "vin": this.Vinnumber,
          "userType":this.userType,
          "dcCollectorVin": this.isShowDataCollectorCheckBox,
          "nwtStatus": "success"
        }
        this.service.postNetworkTest(obj).subscribe((data) => {
        })

        this.service.captureEvisDataDetails(this.Vinnumber, this.language, this.country, sessionId, this.userId).subscribe((data) => {
        }, (error) => {
          if (localStorage.getItem("lastVisitedScreen") == 'fromDiagnostic'){
            this.service.pageData.next('');
            this.router.navigate(['/info'])
          } else if (localStorage.getItem("lastVisitedScreen") == 'fromRepair')
            this.router.navigate(['/repairProcedures'])
          else if (localStorage.getItem("lastVisitedScreen") == 'fromPostRepair') {
            this.router.navigate(['/postrepairProcedures'])
          }
        })
        console.log('network test finished')
      } else {
        // Network test error
        let sessionId:any = '';
          if(this.dataCollectorEvent == 'FULL') {
              sessionId = this.dataCollectorSessionId;
          } else {
              sessionId = localStorage.getItem("sessionID")
          }

        let obj = {
          "sessionID": sessionId,
          "vin": this.Vinnumber,
          "userType":this.userType,
          "dcCollectorVin": this.isShowDataCollectorCheckBox,
          "nwtStatus": "failed"
        }
        this.service.postNetworkTest(obj).subscribe((data) => {
        })
        this.networkTestErrorMsg = data.reason;
        this.modalService.open(this.NWTErrorInfo, { size: 'lg' });
        this.isNetworkFailure = true;
        console.log("data.reason1"+ data.reason)
        if (data.reason == "Unable to communicate to the vehicle. Make sure the Ignition is turned ON and that the DLC and USB connections are OK. If Ok then go to the Menu-Device Manager and verify you are connecting to the appropriate VCI Device. ") {
          this.reasonKey = "1004";
        }
        else if(data.reason=="Unable to read vins"){
          this.reasonKey="1003"
        }
        else if(data.reason=="Lost communication to vehicle"){
          this.reasonKey="1005"
        }
        else if(data.reason=="VIN Mismatch"){
          this.reasonKey="1006"
        }
        const vinDetails = this.service.getVinDetailsSnapshot();
        console.log("vinDetails",vinDetails)
        // null-safe
        //      const vehicleLineDescription = vinDetails?.vehicleLine || vinDetails?.vehicle_line || '';

        let reportdto={
          "vin": this.Vinnumber,
          "id": this.reasonKey,
          "vehicleType":vinDetails?.vehicleLineDescription,
          "market": this.market,
          "dealerCode":this.dealerCode,
          "gnumber":"not applicable"
        }
        this.service.reportdetails(reportdto).subscribe((data)=>{});

        if (this.isUserAdmin) {
          setTimeout(() => {
            console.log("Admin fail called");
            this.service.isNWTInProgress.next('NWTNotRunning');
            this.isShowOverrideBlock = false;
            this.isShowTestProgressBlock = false;
            this.isShowReRunBlock = false;
            this.isNWTestFailedMultiple = false;
            this.isNetworkTestError = false;
            this.isNWTestFailedAdmin = true;
            this.service.setShowWhatsNew(true);
          }, 5000);
        } else {
          this.retryNetworkTestCount = this.retryNetworkTestCount + 1;
          if (this.retryNetworkTestCount >= this.maxFailureTimes) {
            setTimeout(() => {
              this.isShowOverrideBlock = false;
              this.isShowTestProgressBlock = false;
              this.isShowReRunBlock = false;
              this.isNWTestFailedMultiple = true;
              this.isNetworkTestError = false;
              this.isNWTestFailedAdmin = false;
              this.service.setShowWhatsNew(true);
              this.service.isNWTInProgress.next('NWTNotRunning');
            }, 5000)
          } else {
            setTimeout(() => {
              this.isNetwork = data;
              this.progressbar = false;
              this.isNetworkTestError = true;
              this.isShowTestProgressBlock = false;
              this.service.isNWTInProgress.next('NWTNotRunning');
              this.service.setShowWhatsNew(true);
            }, 5000)
          }
        }
      }
      // }
    })
  }

  getDataCollectorCheckboxStatus(DataCollectorEvent: any) {
    this.service.dataCollectorInfo.next(DataCollectorEvent)
    this.dataCollectorEvent = DataCollectorEvent;
    console.log('------------Data Collector Event------------------', DataCollectorEvent);
  }

  retryFDRSConnection() {
    this.service.setShowWhatsNew(true);
    this.showLoader = true;
    this.noOfWebSocketConnRetry = 0;
    if (localStorage.getItem("connectionState") == '1') {
      setTimeout(() => {
        this.rpcClientService.checkFDRSConnectionStatus();
      }, 1000)

    } else if (localStorage.getItem("connectionState") != '1') {
      this.fdrsClient.initFdrsClient("")
    }
  }

  ShowNetworkTestBlock() {
    //this.service.getWebsocketStatus.next("test")
    this.showLoader = false;
    this.service.setShowWhatsNew(true);
    this.isFDRSWebSoecketConnected = true;
    this.getNetworkTestFailureAttempts()
    this.service.isNetworkTestNeeded(this.Vinnumber,this.userTypeId,this.countrythree).subscribe((data) => {
      this.isNetworkTestNeeded = data.status;
      if (this.isUserAdmin && this.isFDRSWebSoecketConnected && this.isNetworkTestNeeded) {
        this.isShowOverrideBlock = true;
      } else if (!this.isUserAdmin && this.isFDRSWebSoecketConnected && this.isNetworkTestNeeded) {
        this.startNetworkTest();
      } else if (!this.isNetworkTestNeeded) {
        this.isShowReRunBlock = true;
      }
      if(this.isNetworkTestNeeded && !this.isUserAdmin && data.adhocParameter.value == 'true') {
        this.modalService.open(this.DTCInfo, { size: 'md' });
      }
    })

  }

  showNetworkTestErrorBlock() {
    //this.service.getWebsocketStatus.next("test")
    this.service.setShowWhatsNew(true);
    this.showLoader = false;
    this.service.setShowWhatsNew(true);
    this.isFDRSWebSoecketConnected = false;
    this.rpcClientService.checkWebSocketConnectionStatus();

  }

  getNetworkTestFailureAttempts() {
    this.service.setShowWhatsNew(true);
    this.service.getReRunNetworkTestConfiguration(this.userTypeId, this.market).subscribe((data: any) => {
      console.log("NWT Component: rerunconfig:", data);
      this.maxFailureTimes = data;
    })
  }


  startNetworkTest() {
    this.service.setShowWhatsNew(true);
    this.networkTestState = "startNWT";
    if(this.dataCollectorEvent == 'FULL') {
      const req = {
        "userId": this.userId,
        "sessionSource": "gfdrs",
        "vin": this.Vinnumber
      }
      this.service.createSession(req).subscribe((data: any) => {
        this.dataCollectorSessionId = data;
        localStorage.setItem('DCSessionId', data);
        console.log('Data Collector Session ID:-------------------->', data);
      });
    }
    this.retryFDRSConnection();
  }

  showStartNetworkTestBlock() {
    this.service.setShowWhatsNew(true);
    this.showLoader = false;
    this.isFDRSWebSoecketConnected = true;
    this.service.isNWTInProgress.next('NWTRunning');
    this.progressbar = true;
    this.isShowOverrideBlock = false;
    this.isShowTestProgressBlock = true;
    this.rpcClientService.runNetworkTest("", "");
  }

  overrideBtnClicked() {
    localStorage.setItem('DCSessionId', '');
    this.service.setShowWhatsNew(false);
    this.service.isNWTInProgress.next('NWTOverride');
    // this.isDisableStartDiagnosticBtn = false;
    this.isShowOverrideBlock = false;
    this.isDisableNwHeader = true;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    let obj = {
      "sessionID": localStorage.getItem("sessionID"),
      "vin": this.Vinnumber,
      "userType":this.userType,
      "dcCollectorVin": this.isShowDataCollectorCheckBox,
      "nwtStatus": "overridden"
    }
    this.service.postNetworkTest(obj).subscribe((data) => {
      if (localStorage.getItem("lastVisitedScreen") == 'fromDiagnostic'){
        this.service.pageData.next('');
        this.router.navigate(['/info'])
      } else if (localStorage.getItem("lastVisitedScreen") == 'fromRepair')
        this.router.navigate(['/repairProcedures'])
      else if (localStorage.getItem("lastVisitedScreen") == 'fromPostRepair') {
        this.router.navigate(['/postrepairProcedures'])
      }
    })

  }

  reRunNetworkTest() {
    // this.networkTestState = "reRunNWT";
    // this.retryFDRSConnection();
    this.service.setShowWhatsNew(true);
    console.log('DC RE-RUN N/W TEST------------------>', this.dataCollectorEvent);
    this.networkTestState = "reRunNWT";
    if(this.dataCollectorEvent == 'FULL') {
      const req = {
        "userId": this.userId,
        "sessionSource": "gfdrs",
        "vin": this.Vinnumber
      }
      this.service.createSession(req).subscribe((data: any) => {
        this.dataCollectorSessionId = data;
        localStorage.setItem('DCSessionId', data);
        console.log('Data Collector Session ID:-------------------->', data);
        this.retryFDRSConnection();
      },(error : any)=> {
          console.log('Error while creating a session in Data collector mode:', error);
      });
    } else {
      this.retryFDRSConnection();
    }
  }

  showReRunNetworkTestBlock() {
    this.service.setShowWhatsNew(true);
    this.showLoader = false;
    this.isFDRSWebSoecketConnected = true;
    this.service.isNWTInProgress.next('NWTRunning');
    this.isNetworkFailure = false;
    // this.isDisableStartDiagnosticBtn = true;
    this.progressbar = true;
    this.isNetwork = false;
    this.isShowTestProgressBlock = true;
    this.isNetworkTestNeeded = true;
    this.isShowReRunBlock = false;
    this.rpcClientService.runNetworkTest("", "");
  }

  retryNetworkTest() {
    this.networkTestState = 'retryNWT';
    this.retryFDRSConnection();
    this.service.setShowWhatsNew(true);
  }

  showRetryNetworkTestBlock() {
    this.service.setShowWhatsNew(true);
    this.showLoader = false;
    this.isFDRSWebSoecketConnected = true;
    this.service.isNWTInProgress.next('NWTRunning');
    this.isNetworkFailure = false;
    this.progressbar = true;
    this.isNetwork = false;
    this.isShowTestProgressBlock = true;
    this.isNetworkTestNeeded = true;
    this.isShowReRunBlock = false;
    this.isNetworkTestError = false;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    this.rpcClientService.runNetworkTest("", "");
  }

  dismissNWTErrorPopUp() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.NWTStatus.unsubscribe();
    this.freshWebSocetSubscription.unsubscribe();
    this.webSocketsubscription.unsubscribe();
    if (this.showWhatsNewSubscription) { // Unsubscribe from new subscriptions
      this.showWhatsNewSubscription.unsubscribe();
    }
    if (this.whatsNewScrollSubscription) { // Unsubscribe from new subscriptions
      this.whatsNewScrollSubscription.unsubscribe();
    }
  }
}
